import React from 'react'

import { useAppSelector } from '../../App/Hooks/reduxHooks'

import { BarLoaderContainer, BarLoader } from './style'

export const CalendarLoader = () => {
  const { calendarStatus } = useAppSelector(state => ({
    calendarStatus: state.calendarNew.status,
  }))

  return (
    <BarLoaderContainer isLoading={calendarStatus === 'loading'}>
      <BarLoader />
    </BarLoaderContainer>
  )
}
